
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class SelectableIconCard extends Vue {
  @Prop({ default: false }) active!: boolean;
  @Prop({ default: "" }) icon!: string;
  @Prop({ default: "" }) text!: string;
}
